<template>
  <div class="content_test">
    <div class="content_wrap">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index" @click="pageTransition(item)">
            <img :src="item.cover" alt="" class="swiper-image" />
            <p class="image-title">{{ item.title }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 视频详情组件 -->
    <div class="video_detail" v-if="VideoDetailsIsShow" @click.self="closeDetail">
      <button class="video_close" @click="closeDetail">&times;</button>
      <div class="video_detail_content">
        <div class="content_top">
          <div class="content_top_left">
            <video :src="videoDetailMsg.link" autoplay controls muted></video>
          </div>
          <div class="content_top_right">
            <div class="content_top_r_item" v-for="videoItem in bannerList">
              <div class="item_img">
                <img :src="videoItem.cover" alt="">
                <div class="video_play" @click="pageTransition(videoItem)">
                  <div class="video_play_icon">
                  </div>
                </div>
              </div>
              <!-- 添加类名来控制文本省略 -->
              <p class="ellipsis-text">{{ videoItem.title }}</p>
            </div>
          </div>
        </div>
        <div class="content_bottom">
          <div class="content_bottom_text">
            <h2>{{ videoDetailMsg.title }}</h2>
            <p>{{ videoDetailMsg.describe }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

export default {
  data() {
    return {
      // baseUrl: 'https://www.hecoos.com/',
      list: [],
      VideoDetailsIsShow: false,
      videoDetailMsg: {},
      videoList: {},
    };
  },
  props: {
    bannerList: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.bannerList.length > 0) {
        new Swiper(".swiper-container", {
          loop: false,
          slidesPerView: 5,
          paginationClickable: true,
          spaceBetween: 0,
          initialSlide: 3,
          centeredSlides: true,
        });
      }
    });
  },
  methods: {
    pageTransition(item) {
      if (item && item.link) {
        this.videoDetailMsg = item;
        this.VideoDetailsIsShow = true;
        // 根据视频详情组件的显示状态来控制页面的滚动条
        // 如果VideoDetailsIsShow为true（即视频详情组件显示），则禁止页面滑动
        // 如果为false（即视频详情组件隐藏），则恢复页面的正常滑动
        this.VideoDetailsIsShow ? document.body.style.overflow = 'hidden' : document.body.style.overflow = 'auto';
      } else {
        console.error("item is undefined or does not have a link property");
      }
    },
    closeDetail() {
      // 将视频详情组件的显示状态设置为隐藏
      this.VideoDetailsIsShow = false;
      // 恢复页面的正常滑动
      document.body.style.overflow = 'auto';
    }
  },
};
</script>

<style lang="scss" scoped>
.content_test {
  padding: 0px 30px;
  box-sizing: border-box;
  /* background-color: #000; */
}

.content_wrap {
  width: 100%;
  overflow-y: visible;
  overflow-x: clip;
  padding: 30px 0px;
}

.swiper-container {
  width: 100%;
  overflow: initial;
}
.swiper-slide {
  display: block;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  filter: brightness(0.4); /* 初始暗化效果 */
  transition: filter 0.3s ease; /* 添加过渡效果 */

 .image-title {
    opacity: 0;
  }
}

.swiper-slide-active {
  z-index: 3;
  transform: scale(1.4)!important;
  filter: brightness(1); /* 选中时恢复亮度 */

 .image-title {
    opacity: 1;
  }
}

.swiper-slide-prev,
.swiper-slide-next {
  z-index: 2;
  transform: scale(1.2)!important;
  filter: brightness(0.4); /* 相邻幻灯片也暗化 */

 .image-title {
    opacity: 0;
  }
}

.swiper-slide .swiper-image {
  width: 100%;
  height: 260px;
  object-fit: cover;
  display: block;
  transition: transform 0.64s ease;
  position: relative;
}

.image-title {
  position: absolute;
  top: calc(55% - 25px);
  left: calc(50% - 90px);
  font-size: 18px;
  color: #fff;
  z-index: 3;
  pointer-events: none;
  width: 180px;
  height: 50px;
}

// 视频详情组件
.video_detail {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.9);
  position: fixed; // 修改为 fixed 定位
  top: 0;
  left: 0;
  padding: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; // 添加 z-index 确保在其他元素之上

  .video_close {
    width: 54px;
    height: 54px;
    line-height: 54px;
    border-radius: 50%;
    font-size: 24px;
    color: #fff;
    border: none;
    background-color: rgba(0, 0, 0, 0.6);
    // background-color: red;
    cursor: pointer;
    position: absolute; // 添加绝对定位
    top: 10px; // 距离顶部10px
    right: 10px; // 距离右侧10px
  }

  .video_detail_content {
    width: 84%;
    height: 84%;
    // background-color: red;

    .content_top {
      height: calc(100% - 150px);
      display: flex;
      justify-content: space-between;

      .content_top_left {
        width: 70%;

        video {
          width: 100%;
          height: 100%;
        }
      }

      .content_top_right {
        width: 27%;
        overflow-y: auto;
        /* 添加垂直滚动 */
        overflow-x: hidden;
        /* 隐藏水平滚动条 */

        &::-webkit-scrollbar {
          display: none;
          /* 隐藏滚动条 */
        }

        .content_top_r_item {
          width: 100%;
          height: 110px;
          margin-bottom: 10px;
          display: flex;
          // flex-wrap: wrap;
          justify-content: left;

          .item_img {
            // width: 40%;
            min-width: 40%;
            max-width: 40%;
            height: 100%;
            margin-right: 18px;
            position: relative;
            box-sizing: border-box;
            cursor: pointer;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .video_play {
              width: 54px;
              height: 54px;
              border: 2px solid #fff;
              border-radius: 50%;
              position: absolute;
              top: calc(50% - 27px);
              left: calc(50% - 27px);

              .video_play_icon {
                // opacity: 0;
                width: 20px;
                height: 20px;
                border-top: 10px solid transparent;
                border-bottom: 10px solid transparent;
                border-left: 15px solid #fff;
                transform: translateX(6px);
                position: absolute;
                top: calc(50% - 10px);
                left: calc(50% - 10px);
              }
            }
          }

          // 新增样式来控制文本省略
          .ellipsis-text {
            height: 72px;
            line-height: 24px;
            padding: 0;
            margin-top: 12px;
            color: #838383;
            font-size: 16px;
            text-align: left;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .content_bottom {
      margin-top: 24px;
      color: #fff;
      text-align: left;

      h2 {
        font-size: 28px;
        font-weight: 700;
        padding-left: 12px;
        margin-bottom: 12px;
      }

      p {
        font-size: 18px;
        padding-left: 6px;
      }
    }
  }
}
</style>